function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import styled from 'styled-components';
import { SIZES, Button, Typography, COLORS } from '@fupa/fupa-uikit';
import { authorizedAPI } from 'app/services/api';
import { useForm } from 'react-hook-form';
import { isFilled } from 'app/helpers/ValidationRules';
import { TextField, useMediaQuery, useTheme } from '@mui/material';
import { Dialog } from 'app/components/dialog/Dialog';
import MarketplaceRequestSummary from 'app/components/marketplace/marketplaceContactForm/MarketplaceRequestSummary';
const postContactMessage = (id, message, club) => {
  const data = {
    club,
    message
  };
  return authorizedAPI.post("".concat(process.env.API_URL, "v2/marketplace/").concat(id, "/contact"), data);
};
const FormContainer = styled.div.withConfig({
  componentId: "sc-1n6zj0y-0"
})(["display:flex;padding:", ";flex-direction:column;gap:0.5rem;"], SIZES['16']);
const StyledTypography = styled(Typography).withConfig({
  componentId: "sc-1n6zj0y-1"
})(["&&&{font-style:italic;}"]);
const MarketplaceContactForm = _ref => {
  var _errors$message$messa, _errors$message;
  let {
    detailId,
    requestData,
    user,
    onContactResolve,
    onContactReject,
    handleClose,
    open
  } = _ref;
  const [disabled, setDisabled] = useState(false);
  const {
    register,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm({
    defaultValues: {
      club: '',
      message: ''
    },
    mode: 'onBlur',
    reValidateMode: 'onChange'
  });
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const onSubmit = _ref2 => {
    let {
      club,
      message
    } = _ref2;
    // This function will only be called, if all inputs are valid
    setDisabled(true);
    postContactMessage(detailId, message, club).then(() => {
      setDisabled(false);
      onContactResolve();
    }).catch(error => {
      setDisabled(false);
      onContactReject(error);
    });
  };
  const actionContent = /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    label: "Nachricht senden",
    onClick: handleSubmit(onSubmit)
  });
  return /*#__PURE__*/React.createElement(Dialog, {
    actionAlign: "flex-end",
    actionContent: actionContent,
    closeable: true,
    fullScreen: fullScreen,
    handleClose: handleClose,
    open: open,
    title: "Nachricht schreiben",
    zIndex: 1999999999,
    "data-sentry-element": "Dialog",
    "data-sentry-component": "MarketplaceContactForm",
    "data-sentry-source-file": "MarketplaceContactForm.tsx"
  }, /*#__PURE__*/React.createElement(FormContainer, {
    "data-sentry-element": "FormContainer",
    "data-sentry-source-file": "MarketplaceContactForm.tsx"
  }, /*#__PURE__*/React.createElement(MarketplaceRequestSummary, {
    club: requestData.club,
    authorName: requestData.authorName,
    title: requestData.title,
    "data-sentry-element": "MarketplaceRequestSummary",
    "data-sentry-source-file": "MarketplaceContactForm.tsx"
  }), /*#__PURE__*/React.createElement(TextField, _extends({
    id: "standard-textarea",
    label: "Nachricht",
    color: "secondary",
    multiline: true,
    minRows: 3,
    required: true,
    InputLabelProps: {
      required: false,
      shrink: true
    }
  }, register('message', {
    validate: isFilled
  }), {
    error: !!errors.message,
    helperText: (_errors$message$messa = (_errors$message = errors.message) === null || _errors$message === void 0 ? void 0 : _errors$message.message) !== null && _errors$message$messa !== void 0 ? _errors$message$messa : ' ',
    "data-sentry-element": "TextField",
    "data-sentry-source-file": "MarketplaceContactForm.tsx"
  })), /*#__PURE__*/React.createElement(TextField, _extends({
    InputLabelProps: {
      shrink: true
    },
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "Verein", /*#__PURE__*/React.createElement(StyledTypography, {
      variant: "caption1"
    }, " - optional")),
    color: "secondary",
    helperText: " "
  }, register('club'), {
    "data-sentry-element": "TextField",
    "data-sentry-source-file": "MarketplaceContactForm.tsx"
  })), /*#__PURE__*/React.createElement(TextField, {
    color: "secondary",
    label: "Profilname",
    name: "name",
    fullWidth: true,
    helperText: " ",
    InputProps: {
      readOnly: true
    },
    value: user.displayName,
    disabled: true,
    sx: {
      '.MuiInputBase-input': {
        background: COLORS.lightestGrey
      }
    },
    "data-sentry-element": "TextField",
    "data-sentry-source-file": "MarketplaceContactForm.tsx"
  }), /*#__PURE__*/React.createElement(TextField, {
    disabled: true,
    color: "secondary",
    label: "Email",
    type: "email",
    name: "email",
    value: user.email,
    helperText: "Deine Daten werden dem Inserenten zur direkten Kontaktaufnahme \xFCbermittelt.",
    sx: {
      '.MuiInputBase-input': {
        background: COLORS.lightestGrey
      }
    },
    InputProps: {
      readOnly: true
    },
    "data-sentry-element": "TextField",
    "data-sentry-source-file": "MarketplaceContactForm.tsx"
  })));
};
export default MarketplaceContactForm;